var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { Sentry, SentryTeam } from 'app/utils/sentry';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import { formatPortsHelper } from '../../../powerFlowShared/helpers/nodePortFormatter';
import ActionModal from '../../containers/modals/widgetcustomization';
const portTranslator = (node) => {
    return [
        {
            id: uuid(),
            type: 'out',
            label: 'arrow',
            connection: node.payload.nextNodeId || uuid(),
        },
    ];
};
export class WidgetCustomizationNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    render() {
        const { node } = this.props;
        const { payload } = node;
        const { theme, medium, small } = payload;
        const mobilePosition = small === null || small === void 0 ? void 0 : small.minimized_view.position.replace('_', ' ');
        const desktopPosition = medium === null || medium === void 0 ? void 0 : medium.minimized_view.position.replace('_', ' ');
        if (!small || !medium)
            Sentry.captureMessage('Invalid Widgetcustomization', {
                contexts: {
                    node: Object.assign(Object.assign({}, node), { payload: JSON.stringify(payload) }),
                },
                tags: { team: SentryTeam.Routing },
            });
        const pillStyle = {
            display: 'inline-block',
            backgroundColor: theme.color,
            width: '30px',
            height: '12px',
            borderRadius: '6px',
            margin: '0 2px -1px',
        };
        return (_jsx(FlowNode, { color: WidgetCustomizationNode.color, icon: WidgetCustomizationNode.icon, label: WidgetCustomizationNode.label, text: _jsxs(Text.Paragraph, Object.assign({ clamp: 2 }, { children: ["Theme color: ", _jsx("span", { style: pillStyle }), mobilePosition && desktopPosition && (_jsxs(_Fragment, { children: [", Position:", _jsxs("strong", { children: [mobilePosition, " on mobile and ", desktopPosition, " on desktop"] })] }))] })), onEdit: this.triggerEdit }));
    }
}
WidgetCustomizationNode.icon = 'widget-customize';
WidgetCustomizationNode.label = 'Customization';
WidgetCustomizationNode.color = flowNodeColor.blue;
WidgetCustomizationNode.height = FlowNode.dimensions.h + 16;
WidgetCustomizationNode.translatePayload = formatPortsHelper(portTranslator);
WidgetCustomizationNode.ActionModal = ActionModal;
WidgetCustomizationNode.actionTrigger = { type: FlowNodeTypes.WIDGET_CUSTOMIZATION };
WidgetCustomizationNode.updateConnection = (node, _port, newConnection) => {
    const { payload } = node;
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { nextNodeId: newConnection }) });
};
__decorate([
    boundMethod
], WidgetCustomizationNode.prototype, "triggerEdit", null);
